
<div class="center-xy" *ngIf="subtitles.downloaded">
    <div class="registration-box bg-light box-shadow" data-testid="registration-form">
        <input type="text" required
               class="register-module__input font-14"
               [ngClass]="{'border-error': !validUsername, 'border-ok': validUsername}"
               [(ngModel)]="username"
               (ngModelChange)="validateUsername()"
               [placeholder]="subtitle(1637) + ' (min. 6 ' + subtitle(1142) + ')'"
               autocomplete="off">
        <input type="email" required
               class="register-module__input font-14"
               [ngClass]="{'border-error': !validEmail, 'border-ok': validEmail}"
               [(ngModel)]="email"
               (ngModelChange)="validateEmail()"
               [placeholder]="subtitle(1110)">
        <input type="password" required
               class="register-module__input font-14"
               [ngClass]="{'border-error': !validPassword, 'border-ok': validPassword}"
               [(ngModel)]="password"
               (ngModelChange)="validatePassword()"
               [placeholder]="subtitle(1101) + ' (min. 8 ' + subtitle(1142) + ')'"
               autocomplete="off">
        <input type="password" required
               class="register-module__input font-14"
               [ngClass]="{'border-error': !validConfirmedPassword, 'border-ok': validConfirmedPassword}"
               [(ngModel)]="confirmedPassword"
               (ngModelChange)="validateConfirmedPassword()"
               [placeholder]="subtitle(1340)"
               autocomplete="off">
        <input type="text"
               *ngIf="forms.isCompanySubdomain('kolton')"
               required
               minlength="1"
               maxlength="45"
               class="register-module__input font-14"
               [ngClass]="{'border-error': !forms.validCity, 'border-ok': forms.validCity}"
               [(ngModel)]="forms.contactForm.city"
               (focus)="forms.validateCity()"
               (ngModelChange)="forms.validateCity()"
               [placeholder]="subtitle(7162)">
        <input type="text"
               *ngIf="forms.isCompanySubdomain('kolton')"
               required
               minlength="1"
               maxlength="45"
               class="register-module__input font-14"
               [ngClass]="{'border-error': !forms.validStreet, 'border-ok': forms.validStreet}"
               [(ngModel)]="forms.contactForm.street"
               (focus)="forms.validateStreet()"
               (ngModelChange)="forms.validateStreet()"
               [placeholder]="subtitle(7161)">
        <input type="text"
               *ngIf="forms.isCompanySubdomain('kolton')"
               required
               minlength="1"
               maxlength="16"
               class="register-module__input font-14"
               [ngClass]="{'border-error': !forms.validHouseNumber, 'border-ok': forms.validHouseNumber}"
               [(ngModel)]="forms.contactForm.houseNumber"
               (focus)="forms.validateHouseNumber()"
               (ngModelChange)="forms.validateHouseNumber()"
               [placeholder]="subtitle(7163)">
        <input type="tel"
               maxlength="16"
               *ngIf="forms.isCompanySubdomain('kolton')"
               class="register-module__input font-14"
               [ngClass]="{'border-error': !forms.validPhone, 'border-ok': forms.validPhone}"
               name="number"
               [(ngModel)]="forms.contactForm.phone"
               (focus)="forms.validatePhone()"
               (ngModelChange)="forms.validatePhone()"
               [placeholder]="subtitle(4697)">
        <input type="text"
               *ngIf="forms.isCompanySubdomain('kolton')"
               minlength="1"
               maxlength="255"
               class="register-module__input font-14"
               [(ngModel)]="forms.contactForm.installerInformation"
               [ngClass]="{'border-error': !forms.validInstallerInformation, 'border-ok': forms.validInstallerInformation}"
               (focus)="forms.validateInstallerInformation()"
               (ngModelChange)="forms.validateInstallerInformation()"
               [placeholder]="subtitle(6440)">


        @if (showRecaptcha) {
            <div class="registration-box captcha-wrapper">
                <re-captcha #captchaRef (resolved)="resolved($event)"
                            [siteKey]="captcha_key">
                </re-captcha>
                @if (!views.isRecaptchaReady) {
                    <loader [dark]="true" class="captcha-loader bg-light"></loader>
                }
            </div>
        }

        <div class="registration-box__policy-box">
            <div class="accept-policy-wrapper font-13">
                <input id="accept_regulations"
                       class="accept-policy__checkbox"
                       type="checkbox"
                       [(ngModel)]="acceptRegulations"
                       (ngModelChange)="setRegisterButtonStatus()">
                <label for="accept_regulations" class="accept-policy__label">
                    {{ subtitle(5130) + '&nbsp;' }}
                </label>
                <a class="link" (click)="appAlert.showDocumentPopup(subtitles.language,'regulations')">
                    {{ subtitle(8419).toLowerCase() + '*' }}
                </a>
            </div>

            <div class="accept-policy-wrapper font-13">
                <input id="accept-policy-general"
                       class="accept-policy__checkbox"
                       type="checkbox"
                       [(ngModel)]="acceptGeneralPolicy"
                       (ngModelChange)="setRegisterButtonStatus()">
                <label for="accept-policy-general" class="accept-policy__label">
                    {{ subtitle(5130) + '&nbsp;' }}
                </label>
                <a class="link" (click)="appAlert.showDocumentPopup(subtitles.language,'generalPolicy')">
                    {{ subtitle(5141) + '*' }}
                </a>
            </div>

            <div class="accept-policy-wrapper font-13">
                <input id="accept-policy"
                       class="accept-policy__checkbox"
                       type="checkbox"
                       [(ngModel)]="acceptPolicy"
                       (ngModelChange)="setRegisterButtonStatus()">
                <label for="accept-policy" class="accept-policy__label">
                    {{ subtitle(5130) + '&nbsp;' }}
                </label>
                <a class="link" (click)="appAlert.showDocumentPopup(subtitles.language,'policy')">
                    {{ subtitle(5141) + '*' }}
                </a>
            </div>

            <div class="accept-policy-wrapper font-13">
                <input id="accept-rules-service24"
                       class="accept-policy__checkbox"
                       type="checkbox"
                       [(ngModel)]="acceptRulesService24"
                       (ngModelChange)="setRegisterButtonStatus()">
                <label for="accept-rules-service24" class="accept-policy__label">
                    {{ subtitle(5130) + '&nbsp;' }}
                </label>
                <a class="link" (click)="appAlert.showDocumentPopup(subtitles.language,'regulations_rules_service24')">
                    {{ subtitle(5141) + '*' }}
                </a>
            </div>

            <button type="submit"
                    [disabled]="createAccountButtonDisable"
                    class="registration-box__button bg-ok color-light font-bold font-19 cursor-pointer"
                    [ngClass]="{'bg-ok': !createAccountButtonDisable, 'bg-default': createAccountButtonDisable}"
                    (click)="createAccount()">
                {{ subtitle(1137) }}
            </button>

            <button class="registration-box__button bg-cancel color-light font-bold font-19 cursor-pointer"
                    (click)="loginScreen()">
                {{ subtitle(1138) }}
            </button>

            <div class="dropdown-list__item forgotten-pass__text font-13 alarm-left">
                <div></div>
                <div class="cursor-pointer color-primary"
                    (click)="goToState('delete_account_login')">
                    {{ subtitle(3806) + '?' }}
                </div>
            </div>
        </div>
    </div>
</div>
